import { createFetchAction } from '../../../../middleware';
import {
    getConfigGatewayUrl, transformAppInit
} from '../../../index';

export const SendVerificationEmailStateName = 'sendVerificationEmail';

export const verifyEmailAction = (userProfileId: string) => {
    return createFetchAction({
        name: SendVerificationEmailStateName,
        body: JSON.stringify({ userProfileId }),
        method: 'POST',
        resolveUrl: getConfigGatewayUrl({
            key: 'UserPortalGateway',
            basePath: '/api/v1/sendVerificationEmail'
        }),
        transformInit: transformAppInit
    });
};
